<template>
  <nuttrema-layout-form-standard class="is-no-center-padding" :edit="edit" :saveError="StuffToEatAllergenDeclaration.saveError">

    <template v-if="edit" slot="center">

      <nuttrema-layout-schedules
       class="is-no-middle-margin-top is-transparent"
       width-west="20em"
       min-width-west="2em"
       width-east="20em"
       min-width-east="2em"
      :enable-east="setManually"
      :show-east="true">

        <div
          slot="west"
          class="section-allergens-list">
          <nuttrema-layout-three-vertical>
            <aside
              slot="top"
              class="menu menu--nuttrema-cred-layout">
              <p class="menu-label">{{ $t('label.allergens_list') }}</p>

              <el-dropdown
                split-button
                type="info"
                size="mini"
                placement="bottom-end"
                trigger="click"
                @command="handleChangeActiveFilter">
                {{ $t('label.show') }}: {{ $t(`label.${activeFilter}`) }}
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="all">
                    {{ $t('label.all') }}
                  </el-dropdown-item>
                  <el-dropdown-item command="major">
                    {{ $t('label.major') }}
                  </el-dropdown-item>
                  <el-dropdown-item command="other_common">
                    {{ $t('label.other_common') }}
                  </el-dropdown-item>
                  <el-dropdown-item command="user_added">
                    {{ $t('label.user_added') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </aside>
            <div
              slot="middle"
              class="allergens-list">

              <div
                 class="allergens-list-group"
                 v-for="group in allergensSorted"
                 v-if="!_isEmpty(group.list)"
                :key="group.key">
                <div class="allergens-list-group__title">
                  <h4>{{ group.title }}</h4>
                </div>

                <div class="allergens-list-group__items">
                  <draggable v-model="group.list" :options="{ group: 'allergen' }" element="ul" class="drag-area without-padding">
                    <li v-for="element in group.list" :key="element.id">
                      <el-popover
                         width="240"
                         trigger="click"
                         placement="bottom"
                        :key="element.id"
                        :title="$t('label.set_as')">
                        <el-button
                          plain
                          size="mini"
                          type="danger"
                          class="el-button--popover"
                          @click="moveFromAllergensListTo(element, group.key, contains)">
                          {{ $t('label.contains') }}
                        </el-button>
                        <el-button
                          plain
                          size="mini"
                          type="warning"
                          class="el-button--popover"
                          @click="moveFromAllergensListTo(element, group.key, mayContain)">
                          {{ $t('label.may_contain') }}
                        </el-button>
                        <el-button
                          plain
                          size="mini"
                          type="success"
                          class="el-button--popover"
                          @click="moveFromAllergensListTo(element, group.key, containsNo)">
                          {{ $t('label.contains_no') }}
                        </el-button>

                        <el-button
                          plain
                          type="info"
                          size="small"
                          slot="reference"
                          class="el-button--allergen"
                         :title="element.tip || ''"
                         :key="element.id">
                         {{ element.name }} <i class="fal fa-ellipsis-v"></i>
                        </el-button>
                      </el-popover>

                    </li>
                  </draggable>
                </div>
              </div>
              <!-- end ~ allergens-list-group -->


            </div>
          </nuttrema-layout-three-vertical>
        </div>
        <!-- end ~ west -->

        <div slot="west-fold">
          <div class="section-allergens-list is-fold">
            <div class="vertical-menu-label">
              <p class="is-left">{{ $t('label.allergens_list') }}</p>
            </div>
          </div>
        </div>
        <!-- end ~ west-fold -->

        <div
          slot="east"
          class="section-allergens-list">
          <nuttrema-layout-three-vertical>
            <aside
              slot="top"
              class="menu menu--nuttrema-cred-layout">
              <p class="menu-label">{{ $t('label.presets') }}</p>
            </aside>

            <div
              slot="middle"
              class="allergens-list">

              <div
                  v-for="group in _get(SettingsPresets, 'data', [])"
                  class="allergens-list-group"
                 :key="group.key">
                <div class="allergens-list-group__title">
                  <h4>{{ group.title }}</h4>
                </div>

                <div class="allergens-list-group__items">
                  <h4 v-if="_isEmpty(group.list)" style="color: gray">{{ $t('label.nothing_added_yet') }}</h4>

                  <ul v-else class="drag-area without-padding">
                    <li v-for="preset in group.list" :key="preset.id">

                      <el-popover
                       width="240"
                       trigger="click"
                       placement="bottom-end"
                       popper-class="el-popover--allergens-info">
                        <el-button
                          plain
                          size="mini"
                          type="success"
                          class="el-button--popover"
                          @click="handleApplyPreset(preset)">
                          {{ $t('label.apply_preset') }}
                        </el-button>

                        <template v-if="group.key === 'added_by_me'">
                          <hr style="margin: 1em 0 0.75em">
                          <popover-question-alert
                             class="is-no-mr"
                             popoverWidth="280"
                             buttonSize="mini"
                             buttonType="danger"
                             buttonClass="el-button--full"
                             buttonTitle="label.delete_preset"
                             popoverPlacement="top-end"
                             popoverTitle="label.delete_preset"
                             popoverText="label.delete_sure"
                            :popoverShouldShow="true"
                            @confirmed="handleDeletePreset(preset.id)">
                          </popover-question-alert>
                        </template>

                        <el-button
                          plain
                          size="small"
                          type="primary"
                          slot="reference"
                          class="el-button--allergen">
                          {{ preset.name }} <i class="far fa-caret-down"></i>
                        </el-button>
                      </el-popover>

                    </li>
                  </ul>

                </div>
              </div>
            </div>
            <!-- end ~ allergens presets midle -->


            <div slot="bottom" class="presets-add-form" style="border-top: 1px solid #dbe2ee; width: 100%; padding: 0.5em;">

              <template v-if="showSaveAsPreset">
                <el-row style="margin-bottom: 0.5em;">
                  <el-col :span="24">
                    <el-input
                      v-model="formData.name"
                      ref="preset_name"
                      size="small"
                      style="width: 100%"
                      @keyup="handlePresetInputEnterKey"
                      :placeholder="$t('label.preset_name')">
                    </el-input>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="17">
                    <el-button
                      size="mini"
                      type="primary"
                      style="width: 100%"
                      :disabled="!formData.name || !checkIsAllergensAdded"
                      :loading="SettingsPresetDetails.saving"
                      @click="handleSavePreset">
                      {{ $t('label.save') }}
                    </el-button>
                  </el-col>
                  <el-col :span="6" :offset="1">
                    <el-button
                       size="mini"
                       type="text"
                       style="width: 100%"
                      @click="handleSaveAsPresetCancel">
                      {{ $t('label.cancel') }}
                    </el-button>
                  </el-col>
                </el-row>
              </template>

              <template v-else>
                <el-button
                   plain
                   size="mini"
                   type="primary"
                   style="width: 100%"
                  :disabled="!checkIsAllergensAdded"
                  @click="handleSaveAsPresetShow">
                  {{ $t('label.save_as_preset') }}
                </el-button>
              </template>

            </div>
          </nuttrema-layout-three-vertical>
        </div>
        <!-- end ~ east -->

        <div slot="east-fold">
          <div class="section-allergens-list is-fold">
            <div class="vertical-menu-label">
              <p>{{ $t('label.presets') }}</p>
            </div>
          </div>
        </div>
        <!-- end ~ west-fold -->

        <template slot="central">
          <div class="allergens-holder">

            <div class="allergens__container">
              <nuttrema-layout-three-vertical>
                <aside
                  slot="top"
                  class="menu menu--nuttrema-cred-layout">
                  <p class="menu-label">{{ $t('label.contains') }}</p>
                </aside>
                <div
                  slot="middle"
                  class="allergens-list">

                  <draggable
                     v-model="contains"
                     element="ul"
                     class="drag-area"
                     data-listname="contains"
                    :move="checkMove"
                    :options="{ group: 'allergen' }">
                    <li v-for="element in contains" :key="element.id">
                      <el-button
                         plain
                         size="small"
                         type="danger"
                         class="el-button--allergen"
                        :title="element.tip">
                        {{ element.name }} <i class="el-icon-delete" @click="removeAddedAllergen(element, contains)"></i>
                      </el-button>
                    </li>
                  </draggable>
                </div>
              </nuttrema-layout-three-vertical>

              <nuttrema-layout-three-vertical v-if="!setManually && !_isEmpty(containsFromIngredient)">
                <aside
                  slot="top"
                  class="menu menu--nuttrema-cred-layout">
                  <p class="menu-label">{{ $t('label.contains_from_ingredient') }}</p>
                </aside>
                <div
                  slot="middle"
                  class="allergens-list">
                  <ul class="drag-area">
                    <li
                       v-for="element in containsFromIngredient"
                       v-if="!_isEmpty(element.AllergenDeclaration.comes_from)"
                      :key="element.id">
                      <el-popover
                         width="240"
                         trigger="click"
                         placement="bottom"
                         popper-class="el-popover--allergens-info">
                        <h4 class="mt-05 mb-025">{{ $t('label.comes_from') }}</h4>
                        <ul>
                          <li v-for="item in _get(element, 'AllergenDeclaration.comes_from', [])" :key="item.id">
                            {{ _get(item, 'Content.name') }}
                          </li>
                        </ul>
                        <el-button
                           plain
                           size="small"
                           type="danger"
                           slot="reference"
                           class="el-button--allergen"
                          :title="element.tip">
                          {{ element.name }} <i class="fal fa-ellipsis-v"></i>
                        </el-button>
                      </el-popover>
                    </li>
                  </ul>
                </div>
              </nuttrema-layout-three-vertical>
            </div>

            <div class="allergens__may_contain">
              <nuttrema-layout-three-vertical>
                <aside
                  slot="top"
                  class="menu menu--nuttrema-cred-layout">
                  <p class="menu-label">{{ $t('label.may_contain') }}</p>
                </aside>
                <div
                  slot="middle"
                  class="allergens-list">
                  <draggable
                     v-model="mayContain"
                     element="ul"
                     class="drag-area"
                     data-listname="may_contain"
                    :move="checkMove"
                    :options="{ group: 'allergen' }">
                    <li v-for="element in mayContain" :key="element.id">
                      <el-button
                         plain
                         size="small"
                         type="warning"
                         class="el-button--allergen"
                        :key="element.id"
                        :title="element.tip">
                        {{ element.name }} <i class="el-icon-delete" @click="removeAddedAllergen(element, mayContain)"></i>
                      </el-button>
                    </li>
                  </draggable>
                </div>
              </nuttrema-layout-three-vertical>

              <nuttrema-layout-three-vertical v-if="!setManually && !_isEmpty(mayContainFromIngredient)">
                <aside
                  slot="top"
                  class="menu menu--nuttrema-cred-layout">
                  <p class="menu-label">{{ $t('label.may_contain_from_ingredient') }}</p>
                </aside>
                <div
                  slot="middle"
                  class="allergens-list">
                  <ul class="drag-area">
                    <li v-for="element in mayContainFromIngredient" :key="element.id">
                      <el-popover
                         width="240"
                         trigger="click"
                         placement="bottom"
                         popper-class="el-popover--allergens-info">
                        <h4 class="mb-05">{{ $t('label.move_to') }}</h4>
                        <el-button
                          plain
                          size="mini"
                          type="danger"
                          class="el-button--popover"
                          @click="moveTo(element, mayContainFromIngredient, contains)">
                          {{ $t('label.contains') }}
                        </el-button>
                        <template v-if="!_isEmpty(element.AllergenDeclaration.comes_from)">
                          <h4 class="mt-05 mb-025">{{ $t('label.comes_from') }}</h4>
                          <ul>
                            <li v-for="item in _get(element, 'AllergenDeclaration.comes_from', [])" :key="item.id">
                              {{ _get(item, 'Content.name') }}
                            </li>
                          </ul>
                        </template>

                        <el-button
                           plain
                           size="small"
                           type="warning"
                           slot="reference"
                           class="el-button--allergen"
                          :title="element.tip">
                          {{ element.name }} <i class="fal fa-ellipsis-v"></i>
                        </el-button>
                      </el-popover>
                    </li>
                  </ul>
                </div>
              </nuttrema-layout-three-vertical>
            </div>

            <div class="allergens__container">
              <nuttrema-layout-three-vertical>
                <aside
                  slot="top"
                  class="menu menu--nuttrema-cred-layout">
                  <p class="menu-label">{{ $t('label.contains_no') }}</p>
                </aside>
                <div
                  slot="middle"
                  class="allergens-list">
                  <draggable
                     v-model="containsNo"
                     element="ul"
                     class="drag-area"
                     data-listname="contains_no"
                    :move="checkMove"
                    :options="{ group: 'allergen' }">
                    <li v-for="element in containsNo" :key="element.id">
                      <el-button
                         plain
                         size="small"
                         type="success"
                         class="el-button--allergen"
                        :title="element.tip">
                        {{ element.name }} <i class="el-icon-delete" @click="removeAddedAllergen(element, containsNo)"></i>
                      </el-button>
                    </li>
                  </draggable>
                </div>
              </nuttrema-layout-three-vertical>

              <template v-if="!setManually && !_isEmpty(containsNoFromIngredient)">
                <nuttrema-layout-three-vertical>
                  <aside
                    slot="top"
                    class="menu menu--nuttrema-cred-layout">
                    <p class="menu-label">{{ $t('label.contains_no_from_ingredient') }}</p>
                  </aside>
                  <div
                    slot="middle"
                    class="allergens-list">
                    <ul
                      class="drag-area">
                      <li v-for="element in containsNoFromIngredient" :key="element.id">
                        <el-popover
                           width="240"
                           trigger="click"
                           placement="bottom"
                          :title="$t('label.move_to')">
                          <el-button
                            plain
                            size="mini"
                            type="danger"
                            class="el-button--popover"
                            @click="moveTo(element, containsNoFromIngredient, contains)">
                            {{ $t('label.contains') }}
                          </el-button>
                          <el-button
                            plain
                            size="mini"
                            type="warning"
                            class="el-button--popover"
                            @click="moveTo(element, containsNoFromIngredient, mayContain)">
                            {{ $t('label.may_contain') }}
                          </el-button>
                          <el-button
                            plain
                            size="mini"
                            type="primary"
                            class="el-button--popover"
                            @click="moveTo(element, containsNoFromIngredient, allergens)">
                            {{ $t('label.remove') }}
                          </el-button>

                          <el-button
                             plain
                             size="small"
                             type="success"
                             slot="reference"
                             class="el-button--allergen"
                            :title="element.tip">
                            {{ element.name }} <i class="fal fa-ellipsis-v"></i>
                          </el-button>
                        </el-popover>
                      </li>
                    </ul>

                  </div>
                  <!-- end ~ alergens-list -->
                </nuttrema-layout-three-vertical>
              </template>
              <!-- end ~ containsNoFromIngredient -->

            </div>

          </div>
          <!-- end ~ allergens-holder -->

          <el-alert
             v-if="setManually && automaticAllergensSupported"
             show-icon
             type="warning"
            :title="$t('label.note')"
            :description="$t('label.recalculate_allergens_note')">
          </el-alert>
        </template>


      </nuttrema-layout-schedules>

    </template>
    <!-- end ~ edit mode -->

    <template v-else slot="center">
      <div
        class="allergens-holder">

        <div class="allergens__container">
          <nuttrema-layout-three-vertical>
            <aside
              slot="top"
              class="menu menu--nuttrema-cred-layout">
              <p class="menu-label">{{ $t('label.contains') }}</p>
            </aside>
            <div
              slot="middle"
              class="allergens-list">
              <ul class="drag-area">
                <li v-for="element in containsSorted" :key="element.id">
                  <el-button
                     v-if="_isEmpty(element.AllergenDeclaration.comes_from)"
                     plain
                     size="small"
                     type="danger"
                     class="el-button--allergen"
                    :title="element.tip">
                    {{ element.name }}
                  </el-button>

                  <el-popover
                     v-else
                     width="240"
                     trigger="click"
                     placement="bottom"
                     popper-class="el-popover--allergens-info">
                    <h4 class="mt-05 mb-025">{{ $t('label.comes_from') }}</h4>
                    <ul>
                      <li v-for="item in _get(element, 'AllergenDeclaration.comes_from', [])" :key="item.id">
                        {{ _get(item, 'Content.name') }}
                      </li>
                    </ul>
                    <el-button
                       plain
                       size="small"
                       type="danger"
                       slot="reference"
                       class="el-button--allergen"
                      :title="element.tip">
                      {{ element.name }} <i class="fal fa-info"></i>
                    </el-button>
                  </el-popover>
                </li>
              </ul>
            </div>
          </nuttrema-layout-three-vertical>
        </div>

        <div class="allergens__container">
          <nuttrema-layout-three-vertical>
            <aside
              slot="top"
              class="menu menu--nuttrema-cred-layout">
              <p class="menu-label">{{ $t('label.may_contain') }}</p>
            </aside>
            <div
              slot="middle"
              class="allergens-list">
              <ul class="drag-area">
                <li v-for="element in mayContainSorted" :key="element.id">
                  <el-button
                     v-if="_isEmpty(element.AllergenDeclaration.comes_from)"
                     plain
                     size="small"
                     type="warning"
                     class="el-button--allergen"
                    :title="element.tip">
                    {{ element.name }}
                  </el-button>

                  <el-popover
                     v-else
                     width="240"
                     trigger="click"
                     placement="bottom"
                     popper-class="el-popover--allergens-info">
                    <h4 class="mt-05 mb-025">{{ $t('label.comes_from') }}</h4>
                    <ul>
                      <li v-for="item in _get(element, 'AllergenDeclaration.comes_from', [])" :key="item.id">
                        {{ _get(item, 'Content.name') }}
                      </li>
                    </ul>
                    <el-button
                       plain
                       size="small"
                       type="warning"
                       slot="reference"
                       class="el-button--allergen"
                      :title="element.tip">
                      {{ element.name }} <i class="fal fa-info"></i>
                    </el-button>
                  </el-popover>
                </li>
              </ul>
            </div>
          </nuttrema-layout-three-vertical>
        </div>

        <div class="allergens__container">
          <nuttrema-layout-three-vertical>
            <aside
              slot="top"
              class="menu menu--nuttrema-cred-layout">
              <p class="menu-label">{{ $t('label.contains_no') }}</p>
            </aside>
            <div
              slot="middle"
              class="allergens-list">
              <ul class="drag-area">
                <li v-for="element in containsNoSorted" :key="element.id">
                  <el-button
                     v-if="_isEmpty(element.AllergenDeclaration.comes_from)"
                     plain
                     size="small"
                     type="success"
                     class="el-button--allergen"
                    :title="element.tip">
                    {{ element.name }}
                  </el-button>

                  <el-popover
                     v-else
                     width="240"
                     trigger="click"
                     placement="bottom"
                     popper-class="el-popover--allergens-info">
                    <h4 class="mt-05 mb-025">{{ $t('label.comes_from') }}</h4>
                    <ul>
                      <li v-for="item in _get(element, 'AllergenDeclaration.comes_from', [])" :key="item.id">
                        {{ _get(item, 'Content.name') }}
                      </li>
                    </ul>
                    <el-button
                       plain
                       size="small"
                       type="success"
                       slot="reference"
                       class="el-button--allergen"
                      :title="element.tip">
                      {{ element.name }} <i class="fal fa-info"></i>
                    </el-button>
                  </el-popover>
                </li>
              </ul>
            </div>
          </nuttrema-layout-three-vertical>
        </div>

      </div>
    </template>

    <template slot="footer">
      <el-dialog
         center
         width="30%"
         append-to-body
        :title="$t('label.attention')"
        :visible.sync="confirmRecalculate">
        <span v-html="_markdown.render($t('label.recalculate_note'))"></span>
        <el-checkbox v-model="preserveUserInputs" style="margin-top: 1em">{{ $t('label.preserve_allergens') }}</el-checkbox>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="confirmRecalculate = false">{{ $t('label.cancel') }}</el-button>
          <el-button size="small" type="primary" @click="handleConfirmRecalculate">{{ $t('label.confirm') }}</el-button>
        </span>
      </el-dialog>

      <div class="footer-row">
        <div class="footer-row__column">
          <el-button type="primary" size="small" :loading="isSaving" @click="submitForm(false)">{{ $t('label.save') }}</el-button>
          <el-button type="text" size="small" @click="cancelChanges">{{ $t('label.cancel') }}</el-button>
        </div>
        <div class="footer-row__column">

          <el-button v-if="setManually" type="text" size="small" @click="handleRemoveAll" class="el-button--icon-left" style="margin-right: 1em">
            <i class="far fa-trash"></i> {{ $t('label.remove_all') }}
          </el-button>

          <template v-if="automaticAllergensSupported">

            <el-button v-if="!setManually" type="text" size="small" @click="confirmRecalculate = true" class="el-button--icon-left" style="margin-right: 1em">
              <i class="far fa-sync-alt"></i> {{ $t('label.recalculate') }}
            </el-button>

            <el-button v-if="setManually" type="info" size="small" class="el-button--icon-left" @click="switchToAutomatic">
              <span class="fa-stack fa-1x" style="height: 1em; line-height: 1em; width: 1em;"><i class="far fa-hand-paper fa-stack-1x"></i><i class="fal fa-times fa-stack-1x"></i></span>  {{ $t('label.turn_off_manual_entry') }}
            </el-button>

            <el-button v-else type="nuttrema-orange" size="small" class="el-button--icon-left" @click="switchToManual">
              <i class="far fa-hand-paper"></i> {{ $t('label.set_manually') }}
            </el-button>
          </template>
        </div>
      </div>
    </template>

  </nuttrema-layout-form-standard>
</template>

<script>
/* eslint-disable object-shorthand */
import Vue from 'vue';
import { findIndex, sortBy, get, union, concat, filter, map, pick, has, pullAllBy, size } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import NuttremaLayoutSchedules from 'components/ui/layout/nuttrema-layout-schedules';
import NuttremaLayoutThreeVertical from 'components/ui/layout/nuttrema-layout-three-vertical';

import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

import draggable from 'vuedraggable';

import StuffToEatInfoSmallCard from 'components/ui/card/stuff-to-eat-info-small-card';
import NuttremaGroupAndSort from 'components/ui/panels/nuttrema-panel-group-and-sort';
import PopoverQuestionAlert from 'components/ui/alert/nuttrema-popover-question-alert';

export default {
  name: 'form-stuff-to-eat-allergens',
  mixins: [FormStandardBehavior],
  props: {
    id: {
      required: false,
      default: null,
    },
    labelPosition: {
      type: String,
      required: false,
      default: 'right',
    },
    AllergensList: {
      type: Object,
      required: false,
    },
    StuffToEatDetails: {
      type: Object,
      required: false,
    },
    SettingsPresets: {
      type: Object,
      required: false,
    },
    StuffToEatAllergenDeclaration: {
      type: Object,
      required: false,
    },
    SettingsPresetDetails: {
      type: Object,
      required: false,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    draggable,
    NuttremaGroupAndSort,
    PopoverQuestionAlert,
    StuffToEatInfoSmallCard,
    NuttremaLayoutSchedules,
    NuttremaLayoutFormStandard,
    NuttremaLayoutThreeVertical,
  },
  data: () => ({
    showSaveAsPreset: false,
    setManually: false,
    preserveUserInputs: true,
    activeFilter: 'all',
    confirmRecalculate: false,
    automaticAllergensSupported: false,
    formData: {
      name: null,
    },
    allergens: [],
    contains: [],
    containsFromIngredient: [],
    mayContain: [],
    mayContainFromIngredient: [],
    containsNo: [],
    containsNoFromIngredient: [],
  }),
  computed: {
    allergensSorted() {
      this.sortAllergens();

      switch (this.activeFilter) {
        case 'all':
          return this.allergens;
        case 'major':
          return filter(this.allergens, group => group.key === 'major');
        case 'other_common':
          return filter(this.allergens, group => group.key === 'other_common');
        case 'user_added':
          return filter(this.allergens, group => group.key === 'user_added');
        default:
          return this.allergens;
      }
    },
    checkIsAllergensAdded() {
      return size(this.contains) + size(this.mayContain) + size(this.containsNo) > 0;
    },
    containsSorted() {
      return sortBy(union(this.contains, this.containsFromIngredient), 'name');
    },
    mayContainSorted() {
      return sortBy(union(this.mayContain, this.mayContainFromIngredient), 'name');
    },
    containsNoSorted() {
      return sortBy(union(this.containsNo, this.containsNoFromIngredient), 'name');
    },
  },
  methods: {
    sortAllergens() {
      const majorList = get(this.allergens, 'major.list', []);
      const otherCommonList = get(this.allergens, 'other_common.list', []);
      const userAddedList = get(this.allergens, 'user_added.list', []);

      this.allergens.major.list = sortBy(majorList, 'seq');
      this.allergens.other_common.list = sortBy(otherCommonList, 'seq');
      this.allergens.user_added.list = sortBy(userAddedList, 'name');
    },
    handleChangeActiveFilter(filter) {
      this.activeFilter = filter;
    },
    setFormData() {
      const allergensList = get(this.AllergensList, 'data', {});

      const allergenDeclarationContainsList = get(this.StuffToEatAllergenDeclaration, 'data.Allergens.contains', []);
      const allergenDeclarationContainsMap = map(allergenDeclarationContainsList, item => pick(item, 'id'));
      this.contains = this.clone(allergenDeclarationContainsList);

      const allergenDeclarationContainsFromIngredientsList = get(this.StuffToEatAllergenDeclaration, 'data.Allergens.contains_from_ingredients', []);
      const allergenDeclarationContainsFromIngredientsMap = map(allergenDeclarationContainsFromIngredientsList, item => pick(item, 'id'));
      this.containsFromIngredient = this.clone(allergenDeclarationContainsFromIngredientsList);

      const allergenDeclarationMayContainList = get(this.StuffToEatAllergenDeclaration, 'data.Allergens.may_contain', []);
      const allergenDeclarationMayContainMap = map(allergenDeclarationMayContainList, item => pick(item, 'id'));
      this.mayContain = this.clone(allergenDeclarationMayContainList);

      const allergenDeclarationMayContainFromIngredientsList = get(this.StuffToEatAllergenDeclaration, 'data.Allergens.may_contain_from_ingredients', []);
      const allergenDeclarationMayContainFromIngredientsMap = map(allergenDeclarationMayContainFromIngredientsList, item => pick(item, 'id'));
      this.mayContainFromIngredient = this.clone(allergenDeclarationMayContainFromIngredientsList);

      const allergenDeclarationContainsNoList = get(this.StuffToEatAllergenDeclaration, 'data.Allergens.contains_no', []);
      const allergenDeclarationContainsNoMap = map(allergenDeclarationContainsNoList, item => pick(item, 'id'));
      this.containsNo = this.clone(allergenDeclarationContainsNoList);

      const allergenDeclarationContainsNoFromIngredientsList = get(this.StuffToEatAllergenDeclaration, 'data.Allergens.contains_no_from_ingredients', []);
      const allergenDeclarationContainsNoFromIngredientsMap = map(allergenDeclarationContainsNoFromIngredientsList, item => pick(item, 'id'));
      this.containsNoFromIngredient = this.clone(allergenDeclarationContainsNoFromIngredientsList);

      const allergenDeclarationMap = concat(allergenDeclarationContainsMap, allergenDeclarationContainsFromIngredientsMap, allergenDeclarationMayContainMap, allergenDeclarationMayContainFromIngredientsMap, allergenDeclarationContainsNoMap, allergenDeclarationContainsNoFromIngredientsMap);

      this.allergens = this.cloneDeep(allergensList);

      if (has(this.allergens, 'major.list')) pullAllBy(this.allergens.major.list, allergenDeclarationMap, 'id');
      if (has(this.allergens, 'other_common.list')) pullAllBy(this.allergens.other_common.list, allergenDeclarationMap, 'id');
      if (has(this.allergens, 'user_added.list')) pullAllBy(this.allergens.user_added.list, allergenDeclarationMap, 'id');

      this.setManually = get(this.StuffToEatDetails, 'data.manual_allergens', false);
      this.automaticAllergensSupported = get(this.StuffToEatAllergenDeclaration, 'data.Entity.automatic_allergens_supported', false);
    },
    getFormData() {
      return {
        contains: map(union(this.contains, this.containsFromIngredient), 'id'),
        may_contain: map(union(this.mayContain, this.mayContainFromIngredient), 'id'),
        contains_no: map(union(this.containsNo, this.containsNoFromIngredient), 'id'),
      };
    },
    removeAddedAllergen(element, list) {
      const origin = get(element, 'origin_list');
      let addedToFromIngredients = 0;

      if (!this.setManually) {
        if (origin === 'contains_from_ingredients') {
          this.containsFromIngredient.push(element);
          addedToFromIngredients += 1;
        } else if (origin === 'may_contain_from_ingredients') {
          this.mayContainFromIngredient.push(element);
          addedToFromIngredients += 1;
        } else if (origin === 'contains_no_from_ingredients') {
          this.containsNoFromIngredient.push(element);
          addedToFromIngredients += 1;
        }
      }

      // Add to allergens list only if not returned to "... from ingredients" list
      if (addedToFromIngredients === 0) {
        const major = get(element, 'major');
        const common = get(element, 'common');

        if (major && common) this.allergens.major.list.push(element);
        else if (common) this.allergens.other_common.list.push(element);
        else this.allergens.user_added.list.push(element);
      }

      this.sortAllergens();

      const index = findIndex(list, item => item.id === element.id);
      Vue.delete(list, index);
    },
    moveTo(element, from, to) {
      console.log('moveTo', element, from, to);
      to.push(element);
      const index = findIndex(from, item => item.id === element.id);
      Vue.delete(from, index);
    },
    moveFromAllergensListTo(element, group, to) {
      to.push(element);

      const from = get(this.allergens, `${group}.list`, []);
      const index = findIndex(from, item => item.id === element.id);

      if (index !== -1) Vue.delete(from, index);

      this.sortAllergens();
    },
    checkMove(evt) {
      if (this.setManually) return true;

      const listName = get(evt, 'to.dataset.listname');
      const origin = get(evt, 'draggedContext.element.origin_list');

      if (origin) {
        if (origin === 'contains_from_ingredients') return false;
        if (origin === 'may_contain_from_ingredients' && listName !== 'contains') return false;
        if (origin === 'contains_no_from_ingredients' && (listName !== 'contains' && listName !== 'may_contain')) return false;
      }

      return true;
    },
    switchToManual() {
      this.setManually = true;

      this.contains = concat(this.contains, this.containsFromIngredient);
      this.mayContain = concat(this.mayContain, this.mayContainFromIngredient);
      this.containsNo = concat(this.containsNo, this.containsNoFromIngredient);

      this.containsFromIngredient = [];
      this.mayContainFromIngredient = [];
      this.containsNoFromIngredient = [];

      this.$emit('setAllergensManualControl', { manual_allergens: true, reload: false });
    },
    switchToAutomatic() {
      this.setManually = false;
      this.$emit('setAllergensManualControl', { manual_allergens: false, reload: true });
    },
    cancelChanges() {
      this.$nextTick(() => {
        if (this.$refs[this.formRef]) this.$refs[this.formRef].clearValidate();
      });
      this.setFormData();
      this.$emit('update:edit', false);
      this.$emit('cancel');
    },
    handleRemoveAll() {
      this.contains = [];
      this.mayContain = [];
      this.containsNo = [];

      this.containsFromIngredient = [];
      this.mayContainFromIngredient = [];
      this.containsNoFromIngredient = [];
    },
    handleConfirmRecalculate() {
      this.confirmRecalculate = false;
      this.$emit('recreateAllergenDeclaration', { preserve_user_inputs: this.preserveUserInputs });
    },
    handleSavePreset() {
      const name = this.formData.name;
      const definition = this.getFormData();

      const payload = {
        name,
        definition,
      };

      this.$emit('savePreset', payload);
      this.handleSaveAsPresetCancel();
    },
    handleDeletePreset(id) {
      this.$emit('deletePreset', id);
    },
    handleApplyPreset(preset) {
      const allergensList = get(this.AllergensList, 'data', {});
      this.allergens = this.cloneDeep(allergensList);

      const contains = get(preset, 'definition.contains', []);
      const mayContain = get(preset, 'definition.may_contain', []);
      const containsNo = get(preset, 'definition.contains_no', []);

      this.contains = this.clone(contains);
      this.mayContain = this.clone(mayContain);
      this.containsNo = this.clone(containsNo);

      this.containsFromIngredient = [];
      this.mayContainFromIngredient = [];
      this.containsNoFromIngredient = [];

      const allergenDeclarationContainsMap = map(this.contains, item => pick(item, 'id'));
      const allergenDeclarationMayContainMap = map(this.mayContain, item => pick(item, 'id'));
      const allergenDeclarationContainsNoMap = map(this.containsNo, item => pick(item, 'id'));

      const allergenDeclarationMap = [...allergenDeclarationContainsMap, ...allergenDeclarationMayContainMap, ...allergenDeclarationContainsNoMap];

      // remove this from allergens list
      if (has(this.allergens, 'major.list')) pullAllBy(this.allergens.major.list, allergenDeclarationMap, 'id');
      if (has(this.allergens, 'other_common.list')) pullAllBy(this.allergens.other_common.list, allergenDeclarationMap, 'id');
      if (has(this.allergens, 'user_added.list')) pullAllBy(this.allergens.user_added.list, allergenDeclarationMap, 'id');
    },
    handleSaveAsPresetShow() {
      this.showSaveAsPreset = true;
      this.$nextTick(() => {
        if (this.$refs.preset_name) this.$refs.preset_name.focus();
      });
    },
    handleSaveAsPresetCancel() {
      this.showSaveAsPreset = false;
      this.formData.name = null;
    },
    handlePresetInputEnterKey(e) {
      const keyCode = e.keyCode;
      if (keyCode === 13) this.handleSavePreset();
    },
  },
  created() {
    this.setFormData();
    this.formRef = 'form-stuff-to-eat-allergens';
    this.stateData = this.StuffToEatAllergenDeclaration;
  },
  watch: {
    StuffToEatAllergenDeclaration: {
      handler: function () {
        this.setFormData();
        this.sortAllergens();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/theme/colors';

.menu--nuttrema-cred-layout {
  width: 100%;
  .el-dropdown {
    width: 100%;
    /deep/ .el-button-group button:first-child {
      text-align: left;
      width: calc(100% - 30px);
    }
  }
}

/deep/ .nuttrema-layout-schedules__central__middle {
  flex-direction: column;
}

.el-button--allergen {
  width: 100%;
  margin-left: 0;
  text-align: left;
  i {
    float: right;
  }
}

.el-button--popover {
  width: 100%;
  margin-top: 0.5em;
  margin-left: 0 !important;
}

.section-allergens-list {
  padding: 0;
  height: 100%;
  overflow-y: auto;
  position: relative;
  background-color: lighten($nutrition-facts-orange-light-bg, 2%);
  &.is-fold {
    padding: 0.75em 0.35em;
  }
  @supports (-moz-appearance: none) {
    height: calc(100vh - 60px);
  }
}

.vertical-menu-label {
  writing-mode: vertical-lr;
  -webkit-writing-mode: vertical-lr;
  p {
    color: #7a7a7a;
    font-size: 0.8em;
    font-weight: 500;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    &.is-left {
      transform: scale(-1);
    }
  }
}

.menu--nuttrema-cred-layout {
  padding: 0.75em;
}

.allergens-list {
  flex-grow: 1;
  display: flex;
  align-self: stretch;
  flex-direction: column;

  .allergens-list-group {
    flex-grow: 0;
    display: flex;
    flex-shrink: 0;
    align-self: stretch;
    flex-direction: column;

    &:last-child {
      flex-grow: 1;
    }

    .allergens-list-group__title {
      display: flex;
      flex-shrink: 0;
      align-self: stretch;
      flex-direction: column;
      justify-content: flex-end;
      padding: 0.75em 0.75em 0.15em;
      border-bottom: 1px solid #dbe2ef;
      margin-bottom: 0.15em;
      > h4 {
        display: flex;
        font-weight: 600;
        color: $gray-light;
        position: relative;
        height: 1.5em;
      }
    }

    .allergens-list-group__items {
      flex-grow: 1;
      flex-shrink: 0;
      display: flex;
      align-self: stretch;
      padding: 0.5em 0.85em 0.5em 0.75em;
      background-color: #fffcf7;

      &.drop-area {
        flex-grow: 1;
        background-color: transparent;
      }
    }
  }
}

.drag-area {
  width: 100%;
  height: 100%;
  margin-bottom: 1em;
  padding: 0.5em 0.85em 0.5em 0.75em;
  li {
    margin-bottom: 0.5em;
    list-style-type: none;
  }

  &.without-padding {
    padding: 0;
  }
}

.allergens-holder {
  flex-grow: 1;
  display: flex;
  flex-shrink: 0;
  align-self: stretch;
  justify-content: space-between;
  padding-left: 0.5em;

  > * {
    display: flex;
    flex-grow: 1;
    max-width: 33.33%;
    flex-basis: 33.33%;
    border-right: 1px solid #dbe2ef;
    flex-direction: column;
    &:last-child {
      border-right: none;
    }
    &.is-full-width {
      max-width: 100%;
      flex-basis: 100%;
    }
  }
}

.presets-add-form {
  width: 100%;
  padding: 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/allergens/form-stuff-to-eat-allergens.vue